module.exports = __webpack_public_path__ + "img/strategy_bb.d8d4472f.svg";